var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({class:_vm.btnclass,attrs:{"color":_vm.color,"disabled":_vm.disabled,"text":_vm.text}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v(_vm._s(_vm.label ? _vm.label : 'Continue'))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }